export enum SexEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  PRENATAL = 'PRENATAL',
}

export const getSexEnumLabel = (value: SexEnum | string) => {
  switch (value) {
    case SexEnum.MALE:
      return $localize`Homme`;
    case SexEnum.FEMALE:
      return $localize`Femme`;
    case SexEnum.PRENATAL:
      return $localize`Pré-natal`;
    default:
      return value;
  }
};

export const getAnimalSexEnumLabel = (
  value: Omit<SexEnum, SexEnum.PRENATAL>
): string => {
  switch (value) {
    case SexEnum.MALE:
      return $localize`Mâle`;
    case SexEnum.FEMALE:
      return $localize`Femelle`;
    default:
      return '';
  }
};
